@if (!hasReported) {
  <div class="dialog report-dialog">
    <h2 mat-dialog-title class="header">
      <span class="title">{{ 'report.dialog_title' | translate }}</span>
      <button class="close-ref" mat-icon-button (click)="close()" [title]="'general.close' | translate | titlecase">
        <mat-icon>clear</mat-icon>
      </button>
    </h2>
    <div class="profile-content" mat-dialog-content>
      @if (reportingEvent) {
        <span>{{'report.dialog_intro_event' | translate}}</span>
      }
      @if (reportingUser) {
        <span>{{'report.dialog_intro_user' | translate}}</span>
      }
      @if (reportingReaction) {
        <span>{{'report.dialog_intro_reaction' | translate}}</span>
      }
      <mat-radio-group [(ngModel)]="selectedReason" class="radio-group">
        @for (reason of reasons; track reason) {
          <mat-radio-button class="radio-button" [value]="reason">
            {{reason}}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (selectedReason === 'Anders, namelijk:') {
        <form [formGroup]="reportFormGroup">
          <mat-form-field appearance="outline" class="size-l">
            <mat-label>{{'report.message_label' | translate}}</mat-label>
            <textarea #message required maxlength="500" autosize rows="3" minRows="3" maxRows="10" matInput formControlName="message" [placeholder]="'report.message_placeholder' | translate"></textarea>
            <mat-hint align="end">{{message.value?.length || 0}} / 500</mat-hint>
            <mat-error>{{'report.message_validation' | translate}}</mat-error>
          </mat-form-field>
        </form>
      }
    </div>
    <div mat-dialog-actions class="dialog-buttons">
      <button class="close-ref" mat-flat-button  (click)="close()" [title]="'general.cancel' | translate">
        {{ 'general.cancel' | translate }}
      </button>
      <button class="close-ref" [disabled]="!selectedReason || (selectedReason === 'Anders, namelijk:' && !reportFormGroup.valid)" [color]="'accent'" mat-flat-button [title]="'feedback.send' | translate" (click)="report()">
        {{ 'feedback.send' | translate }}
      </button>
    </div>
  </div>
}
@if (hasReported) {
  <div class="dialog">
    <h2 mat-dialog-title class="header">
      <span class="title">{{ 'report.dialog_title' | translate }}</span>
      <button class="close-ref" mat-icon-button  (click)="close()" [title]="'general.close' | translate | titlecase">
        <mat-icon>clear</mat-icon>
      </button>
    </h2>
    <div class="profile-content" mat-dialog-content>
      {{ 'report.report_sent' | translate }}
    </div>
  </div>
}
